export default "__VITE_ASSET__BYNUKET6__"